import { ProductTypeName } from '@electricjs/core_entity-client';
import { IconNames } from '@electricjs/arc';

const productTypeIcons: Record<ProductTypeName, IconNames> = {
  laptop: 'laptop',
  desktop: 'desktop',
  mouse: 'mouse',
  keyboard: 'keyboard',
  keyboard_mouse: 'keyboard',
  monitor: 'monitor',
  dock: 'dongle',
  audio: 'audio',
  video: 'webcam',
  warranty: 'shield-check',
  miscellaneous: 'briefcase',
  cell_phone: 'telephone',
  other_phone: 'telephone',
  tablets: 'tablet',
  headphones: 'audio',
  microphone: 'microphone',
  power_adapter: 'battery-bolt',
  cable: 'cord',
  accessory: 'dongle',
  service: 'wrench',
  shipping_and_handling: 'box',
};

export default function getProductTypeIcon(
  productType: ProductTypeName
): IconNames {
  return productTypeIcons[productType] ?? productTypeIcons.miscellaneous;
}
